import React from 'react';

const EyedropperIcon = ({
  width = 24,
  height = 24,
  color = 'currentColor',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.71 5.63128L18.37 3.29128C17.98 2.90128 17.35 2.90128 16.96 3.29128L13.84 6.41128L12.61 5.20128C12.22 4.81128 11.59 4.82128 11.2 5.20128C10.81 5.59128 10.81 6.22128 11.2 6.61128L11.92 7.33128L3.14997 16.1013C3.04997 16.2013 2.99997 16.3213 2.99997 16.4613V20.5013C2.99997 20.7813 3.21997 21.0013 3.49997 21.0013H7.53997C7.66997 21.0013 7.79997 20.9513 7.88997 20.8513L16.66 12.0813L17.38 12.8013C17.77 13.1913 18.4 13.1913 18.79 12.8013C19.18 12.4113 19.18 11.7813 18.79 11.3913L17.57 10.1713L20.69 7.05128C21.1 6.65128 21.1 6.02128 20.71 5.63128ZM6.91997 19.0013L4.99997 17.0813L13.06 9.02128L14.98 10.9413L6.91997 19.0013Z"
      fill={color}
    />
  </svg>
);

export default EyedropperIcon;
